export const ACCOUNT_SID = 'ACed0f5abba6c8a04f534ac7d877bf4c59';
export const VOICE_APP_SID = 'AP4515fd1abf191f5d52ee10682189fb8d'
export const FLEXCHAT_FLOW_SID = 'FOcfd8a927cd4327de1ece527329013354'
export const FORM_ID = '501e07ae-0e40-4f58-8d77-d634b63cccc8'
export const VOICE_APP_CLI = '+447401259740';
export const IDENTITY = 'ciptex-ps-demo';
export const MOCKAPI = '';
export const APIKEY = '8uY7mM3Fa17lsfndMcUbGmUv5lsa8ZYU';